import { render, staticRenderFns } from "./InputComponent.vue?vue&type=template&id=6cd643a6&scoped=true&"
import script from "./InputComponent.vue?vue&type=script&lang=js&"
export * from "./InputComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd643a6",
  null
  
)

export default component.exports